(function () {
    const API_URL = 'https://streetfighter-backend.onrender.com/earlyaccess/subscribe';

    async function submitEmail(email, button, message, form) {
        const originalHTML = button.innerHTML;
        const popupOverlay = form ? form.closest('.popup-overlay, .global-popup-overlay') : null;

        try {
            if (button.dataset.loading === 'true') {
                return;
            }

            button.dataset.originalHTML = originalHTML;

            button.dataset.loading = 'true';
            button.disabled = true;
            button.innerHTML = '<span class="button-spinner" aria-hidden="true"></span>';

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email
                })
            });

            let data = null;

            try {
                data = await response.json();
            } catch (error) {
                data = null;
            }

            if (response.ok) {
                if (message) {
                    message.innerText = 'Thanks for subscribing!';
                    message.setAttribute('role', 'status');
                    message.setAttribute('aria-live', 'polite');
                    message.classList.remove('early-access-error');
                    message.classList.add('early-access-success');
                }

                if (form) {
                    form.reset();
                }

                if (popupOverlay) {
                    popupOverlay.hidden = true;
                    document.body.classList.remove('has-site-popup');
                    document.body.style.overflow = '';
                }

                button.innerHTML = originalHTML;
                button.disabled = false;
                button.dataset.loading = 'false';

                // Clear success after a short timeout
                if (message) {
                    setTimeout(() => {
                        message.classList.remove('early-access-success');
                        // keep text minimal after clear
                        // message.innerText = '';
                    }, 6000);
                }

                return;
            }

            console.error(data);
            if (message) {
                message.innerText = 'Something went wrong. Please try again.';
                message.setAttribute('role', 'alert');
                message.setAttribute('aria-live', 'polite');
                message.classList.remove('early-access-success');
                message.classList.add('early-access-error');
            }
            button.innerHTML = 'TRY AGAIN';

            setTimeout(() => {
                button.innerHTML = originalHTML;
                button.disabled = false;
                button.dataset.loading = 'false';
            }, 2000);
        } catch (err) {
            console.error(err);
            if (message) {
                message.innerText = 'Something went wrong. Please try again.';
                message.setAttribute('role', 'alert');
                message.setAttribute('aria-live', 'polite');
                message.classList.remove('early-access-success');
                message.classList.add('early-access-error');
            }
            button.innerHTML = 'ERROR';

            setTimeout(() => {
                button.innerHTML = button.dataset.originalHTML || originalHTML || 'SUBMIT';
                button.disabled = false;
                button.dataset.loading = 'false';
            }, 2000);
        }
    }

    function bindForm(form) {
        const input = form.querySelector("input[type='email']");
        const button = form.querySelector("button[type='submit']");
        let message = form.querySelector('[data-early-access-message], .early-access-message');

        // If no message node exists, create one so every form has a visible indicator
        if (!message) {
            message = document.createElement('p');
            message.className = 'early-access-message';
            message.setAttribute('data-early-access-message', '');
            message.style.minHeight = '18px';
            form.parentNode && form.parentNode.insertBefore(message, form.nextSibling);
        }

        if (!input || !button) {
            return;
        }

        form.addEventListener('submit', (event) => {
            event.preventDefault();
            const email = input.value.trim();

            if (!email) {
                return;
            }

            submitEmail(email, button, message, form);
        });
    }

    function init() {
        document.querySelectorAll('[data-early-access-form]').forEach(bindForm);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();